import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ElevatorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"elevator"}/>
}
